import { sendErrorToServices } from 'lib/logging';
import { useEffect, useState } from 'react';

export const useFetchSdk = ({ debug = false }: { debug?: boolean } = {}) => {
  const [sdk, setSdk] = useState<unknown | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchSdk = () => {
      const imaUrl = `https://imasdk.googleapis.com/js/sdkloader/ima3${
        debug ? '_debug' : ''
      }.js`;

      const daiUrl = `https://imasdk.googleapis.com/js/sdkloader/ima3_dai${
        debug ? '_debug' : ''
      }.js`;

      const imaSdk = new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = imaUrl;
        script.async = true;

        script.onload = () => {
          const g = window.google;
          if (!g || !g.ima) {
            reject(new Error('IMA SDK blocked by ad blocker or not found'));
          } else {
            resolve(g);
          }
        };

        script.onerror = () => {
          setError('IMA SDK could not load');
          sendErrorToServices(
            'Ad Error',
            `IMA SDK blocked by ad blocker or not found`
          );
        };

        document.body.appendChild(script);
      });

      const daiSdk = new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = daiUrl;
        script.async = true;

        script.onload = () => {
          const g = window.google;
          if (
            !g ||
            !g.ima ||
            !g.ima.dai ||
            !g.ima.dai.api ||
            !g.ima.dai.api.StreamManager
          ) {
            reject(new Error('DAI API blocked by ad blocker or not found'));
          } else {
            resolve(g);
          }
        };

        script.onerror = () => {
          sendErrorToServices(
            'Ad Error',
            `DAI SDK blocked by ad blocker or not found`
          );
        };

        document.body.appendChild(script);
      });

      return Promise.all([imaSdk, daiSdk])
        .then(([ima]) => {
          return { ima };
        })
        .catch(error => {
          sendErrorToServices('Ad Error', `Failed to load SDK: ${error}`);
          setError(error);
          throw error;
        });
    };

    fetchSdk()
      .then(g => setSdk(g.ima))
      .catch(error => {
        setError(error);
      });
  }, [debug]);

  return [sdk, error];
};
